import { useContext } from 'react';

import { StoreContext } from './StoreProvider';

export const withStore = WrappedComponent => {
  function HOC(props) {
    const { store, dispatch } = useContext(StoreContext);
    return <WrappedComponent {...props} dispatch={dispatch} store={store} />;
  }

  return HOC;
};
